module.exports = __webpack_public_path__ + "img/landscape_3.050601a6.jpg";